// A short, local two-note greeting. No remote audio or tracking requests.
export function createAssistantChime() {
  let context;
  const getContext = () => {
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!AudioContext) return null;
    try { context ||= new AudioContext(); return context; } catch { return null; }
  };
  return {
    unlock() {
      const audio = getContext();
      if (audio?.state === 'suspended') audio.resume().catch(() => {});
    },
    play() {
      const audio = getContext();
      // A blocked autoplay greeting stays visual; never queue a surprise sound.
      if (!audio || audio.state !== 'running') return false;
      try {
        [659.25, 880].forEach((frequency, index) => {
          const start = audio.currentTime + index * 0.12;
          const oscillator = audio.createOscillator();
          const gain = audio.createGain();
          oscillator.type = 'sine'; oscillator.frequency.setValueAtTime(frequency, start);
          gain.gain.setValueAtTime(0, start);
          gain.gain.linearRampToValueAtTime(0.045, start + 0.018);
          gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.28);
          oscillator.connect(gain); gain.connect(audio.destination);
          oscillator.onended = () => { oscillator.disconnect(); gain.disconnect(); };
          oscillator.start(start); oscillator.stop(start + 0.3);
        });
        return true;
      } catch { return false; }
    },
    dispose() { if (context && context.state !== 'closed') context.close().catch(() => {}); context = null; },
  };
}
